/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import {Toaster} from "react-hot-toast";
import useStateCallback from "../../../util/customHooks/useStateCallback";
import CardContext from "../../../Context/CardContext";
import SchoolContext from "../../../Context/SchoolContext";
import ajaxCard from "../../../util/remote/ajaxCard";
import MarkCardAsLost from "../../../Components/StudentCard/MarkCardAsLost";
import ActivateCard from "../../../Components/StudentCard/ActivateCard";
import DeActivateCard from "../../../Components/StudentCard/DeActivateCard";
import RenewalPayment from "../../../Components/StudentCard/RenewalPayment";
import AttachRenewalCardSchoolAdmin from "../../../Components/StudentCard/AttachRenewalCardSchoolAdmin";
import AppContainer from "../../../Components/Structure/AppContainer";
import TableHeader from "../../../Components/Common/TableHeader";
import StudentCardSearchForm from "../../../Components/Common/StudentCard/StudentCardSearchForm";
import Loader from "../../../Components/Common/Loader";
import Pagination from "../../../Components/Common/Pagination";

function SchoolCardsPage() {

  const [modal, setModal] = useStateCallback(false);
  const {schoolID, assignedPage, assignedMeta, setAssignedPage, assignedFirst, assignedQuery, setAssignedQuery, loading, loading2,
    schoolAssignedCardsCount, schoolAssignedWristbandsCount, schoolAssignedCardList, getSchoolAssignedCards, searchSchoolAssignedCard, countSchoolAssignedCards, countSchoolAssignedWristbands} = useContext(CardContext);
  const { schoolDetails } = useContext(SchoolContext);
  const [loading3, setLoading3] = useState(false);
  const [loading4, setLoading4] = useState(false);

  const cardSchoolID = schoolDetails.school_id;
  const [schoolLostCardList, setSchoolLostCardList] = useState([]);
  const [lostPage,setLostPage] = useState(1);
  const [lostMeta,setLostMeta] = useState([])
  const [lostFirst, setLostFirst] = useState("");
  const [lostQuery, setLostQuery] = useState("");

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= assignedMeta) {
      setAssignedPage(newPage);
    }
  };

  const handlePagination2 = (newPage) => {
    if (newPage > 0 && newPage <= lostMeta.length) {
      setLostPage(newPage);
    }
  };

  const setCards = (e) => {
    e.preventDefault();
    setAssignedQuery("");
    setAssignedPage(1);
    getSchoolAssignedCards(1);
  };

  const setCards2 = (e) => {
    e.preventDefault();
    setLostQuery("");
    setLostPage(1);
    getSchoolLostCards(1);
  };
  
  useEffect(() => {
    if (assignedQuery) {
      searchSchoolAssignedCard();
    } else {
      getSchoolAssignedCards(assignedPage);
    }
  }, [assignedPage, schoolID]);

  useEffect(() => {
    if (lostQuery) {
      searchSchoolLostCard();
    } else {
      getSchoolLostCards(lostPage);
    }
  }, [lostPage, cardSchoolID]);

  useEffect(() => {
      countSchoolAssignedCards();
     countSchoolAssignedWristbands();
    }, [schoolID]);


  const getSchoolLostCards = async (currentPage) => {
    setLoading3(true);
    const server_response = await ajaxCard.fetchSchoolLostCardList(currentPage,cardSchoolID);
   
    setLoading3(false);
    if (server_response.status === "OK") {
      setLostFirst(server_response.details.meta.offset_count);
      setLostMeta(server_response.details.meta.list_of_pages);
      setSchoolLostCardList(server_response.details.list || []);
    } else {
      setSchoolLostCardList([]);
    }
  };

  const searchSchoolLostCard = async (e) => {
    if (e) {
      e.preventDefault();
    }
      setLoading4(true);
      const server_response = await ajaxCard.searchSchoolLostCard(lostQuery,lostPage,cardSchoolID);
      setLoading4(false);
      if (server_response.status === "OK") {
        setLostFirst(server_response.details.meta.offset_count);
        setLostMeta(server_response.details.meta.list_of_pages);
        setSchoolLostCardList(server_response.details.list || []);
      } else {
        setSchoolLostCardList([]);
      }
  };

  const lostCard=(e,item)=>{
    setModal(false, ()=>setModal(<MarkCardAsLost cardID={item.card_id} getAssignedCards={getSchoolAssignedCards} 
         assignedPage={assignedPage} countAssignedCards={countSchoolAssignedCards} 
         getAllCards={getSchoolAssignedCards}  getInactiveCards={getSchoolAssignedCards} 
          getUnassignedCards={getSchoolAssignedCards} page={assignedPage}  inactivePage={assignedPage} unassignedPage={assignedPage} 
          countAssignedWristbands={countSchoolAssignedWristbands}  isOpen={true}/>))
  }

  const cardOn=(e,item)=>{
    setModal(false, ()=>setModal(<ActivateCard page={assignedPage} inactivePage={assignedPage} getAllCards={getSchoolAssignedCards} getInactiveCards={getSchoolAssignedCards} cardID={item.card_id} isOpen={true}/>))
  }

  const cardOff=(e,item)=>{
    setModal(false, ()=>setModal(<DeActivateCard cardID={item.card_id} page={assignedPage} inactivePage={assignedPage} getAllCards={getSchoolAssignedCards} getInactiveCards={getSchoolAssignedCards} isOpen={true}/>))
  }

  const renewCardPayment=(e,item)=>{
    setModal(false, ()=>setModal(<RenewalPayment userID={item.student.user_id} isOpen={true}/>))
  }

  const assignNewCard=(e,item)=>{
    setModal(false, ()=>setModal(<AttachRenewalCardSchoolAdmin studentID={item.student.student_id} fullName={item.student.full_name} countAssignedCards={countSchoolAssignedCards} countAssignedWristbands={countSchoolAssignedWristbands} assignedPage={assignedPage} getAssignedCards={getSchoolAssignedCards} isOpen={true}/>))
  }
 
  return (
    <AppContainer title="Buzz Cards / Wristbands">
        {modal}
        <Toaster position="top-center" reverseOrder={false} />
        
        <div className="row">
        <div className="col-lg-12">
          <div className="row">
          <div class="col-lg-12">
							<div class="card custom-card " style={{paddingBottom:"10px"}}>
                <div className="card-body map-card gradient-my-blue">
                <div class="item-title mb-2" style={{color:"white"}}><b>SUMMARY</b></div>
								<div class="row" >
									

                  <div class="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right" >
										<div class="text-center" >
											<h2 class="mb-1 number-font" style={{color:"white"}}><span class="counter">{schoolAssignedCardsCount ? schoolAssignedCardsCount.total_p: "..."}</span></h2>
											<p class="mb-0 text-light"> Assigned Cards</p>
										</div>
									</div>

									<div class="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0">
										<div class="text-center">
											<h2 class="mb-1 number-font" style={{color:"white"}}><span class="counter">{schoolAssignedWristbandsCount ? schoolAssignedWristbandsCount.total_p: "..."}</span></h2>
											<p class="mb-0 text-light"> Assigned Wristbands</p>
										</div>
									</div>

                  
								</div>
              </div>
							</div>
            </div>

            <div class="col-lg-12">
              <div className="card custom-card">
              
                <div className="card-body map-card">
                <div className="heading-layout1 mg-b-5">
        <TableHeader
          title="Student Buzz Cards / Wristbands"
          subtitle="List of all the buzz cards and wristbands assigned to the students in the school"  />
        <div className="dropdown">
          <Link className="dropdown-toggle" role="button" data-toggle="dropdown">...</Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link className="dropdown-item">
              <i className="fas fa-file-export"></i>Export
            </Link>
          </div>
        </div>
      </div>
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                  <Row>
                  <Col sm={12}>
                    <Nav variant="pills" className="flex-row mb-1">
                      <Nav.Item>
                        <Nav.Link size="sm" eventKey="first">
                          All{" "}
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link size="sm" eventKey="second">
                          Lost{" "}
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Col>

                  <Col sm={12}>
                    <Tab.Content>
                      <Tab.Pane eventKey="first">
                      <StudentCardSearchForm searchTerm={assignedQuery} setSearchTerm={setAssignedQuery} searchCards={searchSchoolAssignedCard} setCards={setCards} setPage={setAssignedPage} placeholder="Enter card / wristband number or name of student..."/>
                    <div className="table-responsive">
                    {loading || loading2 ? (
                        <Loader /> 
                    ) : (
                        <table className="table display data-table text-nowrap">
                        <thead>
                        <tr>
                        <th scope="col" className="wd-10p">No.</th>
                        <th>Serial Number</th>
                        <th>Type</th>
                        <th>Student Name</th>
                        <th>Status</th>
                        <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        {schoolAssignedCardList.length > 0 ? (
                        schoolAssignedCardList.map((item, index) => (
                        <tr key={index}>
                            <th scope='row' style={{width:"5px"}}>{index + assignedFirst + 1}</th>
                            <td>{item.card_number}</td>
                            <td>{item.type==="CARD"?<span class="badge badge-info">{item.type}</span>:<span class="badge badge-wb">{item.type}</span>}</td>

                            <td><Link to={`/students/profile/${item.student.student_id}/${item.student.user_id}`}>
                                                                {item.student.full_name}
                                                                </Link></td>
                                <td>{item.status==="1"?<span class="badge badge-success">Assigned</span>
                                :<span class="badge badge-danger">De-activated</span>}</td>
                                <td>
                                    <div className="dropdown">
                                    <Link
                                        to="#"
                                        className="dropdown-toggle"
                                        data-toggle="dropdown"
                                        aria-expanded="false">
                                        <span className="flaticon-more-button-of-three-dots"></span>
                                    </Link>
                                    <div className="dropdown-menu dropdown-menu-right">
                                    
                                    
                                        <Link
                                        className="dropdown-item"
                                        to="#"
                                        onClick={(e) => lostCard(e,item)}>
                                        <i className="fa fa-link-slash mr-1" style={{color:"red"}}></i>
                                        Mark as Lost
                                    </Link>
                                    {item.status==="1"?<Link
                                        className="dropdown-item"
                                        to="#"
                                        onClick={(e) => cardOff(e,item)}>
                                        <i className="fa fa-ban mr-1" style={{color:"red"}}></i>
                                        De-Activate / Block
                                    </Link>:<Link
                                        className="dropdown-item"
                                        to="#"
                                        onClick={(e) => cardOn(e,item)}>
                                        <i className="fa fa-power-off mr-1" style={{color:"green"}}></i>
                                        Re-Activate / Unblock
                                    </Link>}</div>
                                    </div>
                                </td>
                        </tr>
                        ))
                        ) : (
                        <tr>
                        <td colSpan="6" style={{ textAlign: "center" }}>
                            No cards or wristbands assigned to students yet.
                        </td>
                        </tr>
                        )}
                        </tbody>
                        </table>
                    )}
                    </div>
                    <Pagination currentPage={assignedPage} totalPages={assignedMeta} onPageChange={handlePagination}/>
                      </Tab.Pane>

                      <Tab.Pane eventKey="second">
                      <StudentCardSearchForm searchTerm={lostQuery} setSearchTerm={setLostQuery} searchCards={searchSchoolLostCard} setCards={setCards2} setPage={setLostPage} placeholder="Enter card / wristband number..."/>
                    <div className="table-responsive">
                    {loading3 || loading4 ? (
                        <Loader /> 
                    ) : (
                        <table className="table display data-table text-nowrap">
                        <thead>
                        <tr>
                        <th scope="col" className="wd-10p">No.</th>
                        <th>Serial Number</th>
                        <th>Type</th>
                        <th>Student Name</th>
                        <th>Status</th>
                        <th>Reason</th>

                        <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        {schoolLostCardList.length > 0 ? (
                        schoolLostCardList.map((item, index) => (
                        <tr key={index}>
                            <th scope='row' style={{width:"5px"}}>{index + lostFirst + 1}</th>
                            <td>{item.card_number}</td>
                            <td>{item.type==="CARD"?<span class="badge badge-info">{item.type}</span>:<span class="badge badge-wb">{item.type}</span>}</td>

                            <td><Link to={`/students/profile/${item.student.student_id}/${item.student.user_id}`}>
                                                                {item.student.full_name}
                                                                </Link></td>
                                <td><span class="badge badge-danger">De-activated</span></td>
                                <td>{item.reason}</td>
                                <td>
                                              <div className="dropdown">
                                                <Link
                                                  to="#"
                                                  className="dropdown-toggle"
                                                  data-toggle="dropdown"
                                                  aria-expanded="false">
                                                  <span className="flaticon-more-button-of-three-dots"></span>
                                                </Link>
                                                <div className="dropdown-menu dropdown-menu-right">
                                                
                                                <Link
                                                  className="dropdown-item"
                                                  to="#"
                                                  onClick={(e) => renewCardPayment(e,item)}
                                                  >
                                                  <i className="fa fa-money-check-dollar mr-1" style={{color:"green"}}></i>
                                                  Pay For Renewal
                                                </Link>
                                                  <Link
                                                  className="dropdown-item"
                                                  to="#"
                                                  onClick={(e) => assignNewCard(e,item)}
                                                  >
                                                  <i className="fa fa-square-plus mr-1"></i>
                                                  Assign Replacement
                                                </Link>
                                                </div>
                                              </div>
                                          </td>
                        </tr>
                        ))
                        ) : (
                        <tr>
                        <td colSpan="7" style={{ textAlign: "center" }}>
                            No lost cards / wristbands yet.
                        </td>
                        </tr>
                        )}
                        </tbody>
                        </table>
                    )}
                    </div>
                    <Pagination currentPage={lostPage} totalPages={lostMeta.length} onPageChange={handlePagination2}/>
                    
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
                </Tab.Container> 
              
            </div>
          </div>
        </div></div>
        </div>
           
        </div>
     
    </AppContainer>
  );
}

export default SchoolCardsPage;